import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Commons, Home, Missions
import enCommon from "./locales/en/common.json";
import ptCommon from "./locales/pt/common.json";
import enMissions from "./locales/en/missions.json";
import ptMissions from "./locales/pt/missions.json";
import enHome from "./locales/en/home.json";
import ptHome from "./locales/pt/home.json";
import en_about from "./locales/en/about.json";
import pt_about from "./locales/pt/about.json";
import en_contact from "./locales/en/contact.json";
import pt_contact from "./locales/pt/contact.json";
import en_careers from "./locales/en/careers.json";
import pt_careers from "./locales/pt/careers.json";
import en_mlbr from "./locales/en/mlbr.json";
import pt_mlbr from "./locales/pt/mlbr.json";
import en_strategic_certification from "./locales/en/strategic-certification.json";
import pt_strategic_certification from "./locales/pt/strategic-certification.json";
import en_category_chemicals from "./locales/en/category/chemicals.json";
import pt_category_chemicals from "./locales/pt/category/chemicals.json";
import en_category_cubesat_deployer_system from "./locales/en/category/cubesat-deployer-system.json";
import pt_category_cubesat_deployer_system from "./locales/pt/category/cubesat-deployer-system.json";
import en_category_eletronic_systems from "./locales/en/category/eletronic-systems.json";
import pt_category_eletronic_systems from "./locales/pt/category/eletronic-systems.json";
import en_category_propulsion_systems from "./locales/en/category/propulsion-systems.json";
import pt_category_propulsion_systems from "./locales/pt/category/propulsion-systems.json";
import en_products_index from "./locales/en/products/index.json";
import pt_products_index from "./locales/pt/products/index.json";
import en_products_arion_liquid_rocket_engine from "./locales/en/products/arion-liquid-rocket-engine.json";
import pt_products_arion_liquid_rocket_engine from "./locales/pt/products/arion-liquid-rocket-engine.json";
import en_products_atlas_htp from "./locales/en/products/atlas-htp.json";
import pt_products_atlas_htp from "./locales/pt/products/atlas-htp.json";
import en_products_bizupod from "./locales/en/products/bizupod.json";
import pt_products_bizupod from "./locales/pt/products/bizupod.json";
import en_products_catalyst from "./locales/en/products/catalyst.json";
import pt_products_catalyst from "./locales/pt/products/catalyst.json";
import en_products_daq from "./locales/en/products/daq.json";
import pt_products_daq from "./locales/pt/products/daq.json";
import en_products_htp from "./locales/en/products/htp.json";
import pt_products_htp from "./locales/pt/products/htp.json";
import en_products_on_board_components from "./locales/en/products/on-board-components.json";
import pt_products_on_board_components from "./locales/pt/products/on-board-components.json";
import en_products_reaction_control_system from "./locales/en/products/reaction-control-system.json";
import pt_products_reaction_control_system from "./locales/pt/products/reaction-control-system.json";
import en_services_index from "./locales/en/services/index.json";
import pt_services_index from "./locales/pt/services/index.json";
import en_services_aerospace from "./locales/en/services/aerospace.json";
import pt_services_aerospace from "./locales/pt/services/aerospace.json";
import en_services_ftl from "./locales/en/services/ftl.json";
import pt_services_ftl from "./locales/pt/services/ftl.json";
import en_services_manufacturing from "./locales/en/services/manufacturing.json";
import pt_services_manufacturing from "./locales/pt/services/manufacturing.json";
import en_services_t8 from "./locales/en/services/t8.json";
import pt_services_t8 from "./locales/pt/services/t8.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      missions: enMissions,
      home: enHome,
      "about": en_about,
      "contact": en_contact,
      "careers": en_careers,
      "mlbr": en_mlbr,
      "strategic-certification": en_strategic_certification,
      "category/chemicals": en_category_chemicals,
      "category/cubesat-deployer-system": en_category_cubesat_deployer_system,
      "category/eletronic-systems": en_category_eletronic_systems,
      "category/propulsion-systems": en_category_propulsion_systems,
      "products/index": en_products_index,
      "products/arion-liquid-rocket-engine": en_products_arion_liquid_rocket_engine,
      "products/atlas-htp": en_products_atlas_htp,
      "products/bizupod": en_products_bizupod,
      "products/catalyst": en_products_catalyst,
      "products/daq": en_products_daq,
      "products/htp": en_products_htp,
      "products/on-board-components": en_products_on_board_components,
      "products/reaction-control-system": en_products_reaction_control_system,
      "services/index": en_services_index,
      "services/aerospace": en_services_aerospace,
      "services/ftl": en_services_ftl,
      "services/manufacturing": en_services_manufacturing,
      "services/t8": en_services_t8,
    },
    pt: {
      common: ptCommon,
      missions: ptMissions,
      home: ptHome,
      "about": pt_about,
      "contact": pt_contact,
      "careers": pt_careers,
      "mlbr": pt_mlbr,
      "strategic-certification": pt_strategic_certification,
      "category/chemicals": pt_category_chemicals,
      "category/cubesat-deployer-system": pt_category_cubesat_deployer_system,
      "category/eletronic-systems": pt_category_eletronic_systems,
      "category/propulsion-systems": pt_category_propulsion_systems,
      "products/index": pt_products_index,
      "products/arion-liquid-rocket-engine": pt_products_arion_liquid_rocket_engine,
      "products/atlas-htp": pt_products_atlas_htp,
      "products/bizupod": pt_products_bizupod,
      "products/catalyst": pt_products_catalyst,
      "products/daq": pt_products_daq,
      "products/htp": pt_products_htp,
      "products/on-board-components": pt_products_on_board_components,
      "products/reaction-control-system": pt_products_reaction_control_system,
      "services/index": pt_services_index,
      "services/aerospace": pt_services_aerospace,
      "services/ftl": pt_services_ftl,
      "services/manufacturing": pt_services_manufacturing,
      "services/t8": pt_services_t8,
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
